const setLocalUserInfo = (userInfo: any) => {
  localStorage.setItem("userInfo", JSON.stringify(userInfo));
};

const getUserInfo = () => {
  const userInfo = localStorage.getItem("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

const setLocalTheme = (theme: string) => {
  localStorage.setItem("theme", theme);
};

const getTheme = () => {
  const theme = localStorage.getItem("theme");
  return theme ?? "light";
};

const setLocalLanguage = (language: string) => {
  localStorage.setItem("language", language);
};

const getLanguage = () => {
  const language = localStorage.getItem("language");
  return language ?? "en";
};

const setLocalTenantId = (tenantId: string) => {
  localStorage.setItem("tenantId", tenantId);
};

const getTenantId = () => {
  const envTenantId = import.meta.env.VITE_X_TENANTID;
  const storedTenantId = localStorage.getItem("tenantId");
  return (envTenantId ?? storedTenantId) ?? null;
};
const setLocalAccessToken = (accessToken: string) => {
  localStorage.setItem("accessToken", accessToken);
};

const getAccessToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  return accessToken ?? null;
};

const setLocalRefreshToken = (refreshToken: string) => {
  localStorage.setItem("refreshToken", refreshToken);
};

const getRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return refreshToken ?? null;
};

const setLocalEmployeeId = (employeeId: string) => {
  localStorage.setItem("employeeId", employeeId);
};

const removeLocalEmployeeId = () => {
  localStorage.removeItem("employeeId");
};

const getEmployeeId = () => {
  const employeeId = localStorage.getItem("employeeId");
  return employeeId ?? null;
};

const setLocalUserRoles = (roles: any) => {
  localStorage.setItem("userRoles", JSON.stringify(roles));
};

const getUserRoles = () => {
  const roles = localStorage.getItem("userRoles");
  return roles ? JSON.parse(roles) : null;
};

const setLocalZulipAuth = (zulipAuth: any) => {
  localStorage.setItem("zulipAuth", JSON.stringify(zulipAuth));
};

const getLocalZulipAuth = () => {
  const zulipAuth = localStorage.getItem("zulipAuth");
  return zulipAuth ? JSON.parse(zulipAuth) : null;
};

const clearLocalStorage = () => {
  localStorage.clear();
};

export {
  clearLocalStorage,
  getAccessToken, getEmployeeId, getLanguage, getLocalZulipAuth, getRefreshToken,
  getTenantId,
  getTheme, getUserInfo, getUserRoles,
  removeLocalEmployeeId,
  setLocalAccessToken, setLocalEmployeeId, setLocalLanguage, setLocalRefreshToken,
  setLocalTenantId,
  setLocalTheme, setLocalUserInfo, setLocalUserRoles, setLocalZulipAuth
};
